import type { I18n } from '@funkey/locales';

/**
 * The one sentence for an activity whose location is not a venue you can pick.
 *
 * Rendered by the widget and by the booking card's locked Location field. They describe the
 * same activity from two corners of the same page, so they must not be able to describe it
 * differently — which is exactly what happened when each carried its own wording: the map said
 * the activity takes place at a location of choice while the card said it takes place at the
 * provider's own.
 */
export function unpinnedLocationStatement(i18n: I18n): string {
    return i18n._('pdp.location.fixed.agreed', undefined, {
        message: 'This activity takes place at a location of choice.',
    });
}
